module.exports = __webpack_public_path__ + "img/image-restaurant.b561f8d5.jpg";